<template>
    <div>
        <div class="main-cnt ex-has-btn-btm">
            <div class="error-message" v-if="errorMessage">
                <div class="d-flex">
                    <i class="icon-warning mr-2"></i>
                    <div class="errror-txt">
                        <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                        <p class="fs-14 text-red font600">{{ errorMessage }}</p>
                    </div>
                </div>
            </div>
            <component
                v-bind:is="component"
                :voucherParams="voucherParams"
                :setErrorMessage="setErrorMessage"
                @voucherSuccess="voucherSuccess"
                @update:actionHandler="$emit('update:actionHandler', $event)"
            ></component>
        </div>
    </div>
</template>

<script>
import Utils from "@/helpers/utils";

import StorageService from "@/services/common/storage.service";

export default {
    components: {},
    name: "SpAddVoucher",
    data () {
        return {
            voucher: {},
            errorMessage: "",
            voucherParams: {},
            screenType: "",
        };
    },
    computed: {
        component: {
            get: function () {
                if (this.voucherParams.voucherTypeId) {
                    let templateId = Utils.getTemplateId(
                        this.voucherParams.voucherTypeId
                    );
                    if (!Utils.isEmptyStr(templateId)) {
                        return () => import(`./Add/Temp_` + templateId + `.vue`);
                    }
                }
            },
        },
    },
    created () {
        if (Utils.isReadOnly()) {
            this.$emit("enableButton");
        } else {
            this.$emit("enableButton", this.$t("button.ok"));
        }
    },
    beforeMount () {
        let params = JSON.parse(StorageService.getVoucher());
        params.transactionDate = new Date(params.transactionDate);
        this.voucherParams = params;
        this.screenType = this.$route.query.screenType;
    },
    methods: {
        setErrorMessage (msg) {
            this.errorMessage = msg;
        },

        voucherSuccess (id) {
            StorageService.saveCurrencyId(this.voucherParams.currencyId + "");
            if (!Utils.isEmptyStr(id)) {
                this.$router.replace({
                    path: "/voucher/detail",
                    query: { voucherId: id, screenType: this.screenType },
                });
                // this.$router.push({path: '/voucher/detail', query: {voucherId: id}});
            } else {
                if (!Utils.isEmptyStr(this.screenType)) {
                    this.$router.replace({
                        path: "/voucher/list",
                        query: { screenType: this.screenType },
                    });
                } else {
                    this.$router.replace({
                        path: "/voucher/list",
                    });
                }
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/sp/Voucher/Add.vue